import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import { fn, get } from "@ember/helper";
import { on } from "@ember/modifier";
import { or } from "ember-truth-helpers";
import IconsCheck from "glesys-controlpanel/components/icons/check";

const isSelected = (selected, value, key) => {
  if (key) {
    return selected[key] === value[key];
  }

  return selected === value;
};
<template>
  <label
    class="cursor-pointer flex items-center relative rounded-lg border p-4 group hover:border-gray-300 has-checked:border-black has-checked:hover:border-black has-focus-visible:ring-2 has-focus-visible:ring-blue-700 has-focus-visible:ring-offset-2"
    {{mergeClasses}}
    ...attributes
  >
    <div
      class="absolute right-2 top-2 grid place-items-center [grid-template-areas:'indicator'] *:[grid-area:indicator]"
    >
      <input
        class="sr-only peer"
        type="radio"
        name={{@group}}
        value={{if @key (get @value @key) @value}}
        checked={{isSelected @selected @value @key}}
        {{(if @onChange (modifier on "change" (fn @onChange @value)))}}
      />
      <div
        class="size-4 rounded-full border border-gray-200 group-hover:border-gray-300 peer-checked:bg-black peer-checked:border-transparent"
      />
      <IconsCheck
        class="size-3 stroke-3 text-white scale-0 peer-checked:scale-100 transition-transform"
        role="presentation"
      />
    </div>
    {{yield}}
    {{#if (or @title @text)}}
      <div class="flex-row ml-3">
        <span class="text-black tracking-wide">
          {{@title}}
        </span>
        <span class="block text-sm font-normal text-gray-600">
          {{@text}}
        </span>
      </div>
    {{/if}}
  </label>
</template>
